/**
 * Best Friend Instagram Subscription Page
 *
 * Página de suscripción a la lista de Close Friends de Instagram de la creadora.
 * El template maneja AR (MercadoPago) y resto del mundo (Stripe) de forma transparente.
 */

import BestFriendInstagramTemplate from "@/components/templates/BestFriendInstagramTemplate";

export default function BestFriendInstagram() {
  return <BestFriendInstagramTemplate />;
}
